<style>
  .children-module-content {
    /* background: transparent !important; */
    padding: 25px !important;
  }
</style>
<template>

  <div class="children-container">
    <div class="children-module-name">申请加入PI团队</div>
    <div class="children-module-info">
      <div>
        <a-button style="margin-bottom: 20px;border-radius: 0px 16px 0px 16px;" type="primary" @click="openModal"
          icon="plus">添加
        </a-button>
      </div>
      <a-table :columns="columns" bordered :data-source="list" rowKey="id" :pagination="false">
        <template slot="state" slot-scope="text, record">
          <a-tag color="green" v-if="text == 'TRUE'">正常关联</a-tag>
          <a-tag v-if="text == 'FALSE'">等待同意</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link" size="small" icon="delete" style="color: #666"
                            @click="openDelete(record['id'])">
                            解除绑定
                        </a-button>
        </template>
      </a-table>
      <div class="page-container">
        <a-pagination :hideOnSinglePage="true" :page-size.sync="page.pageSize" :total="page.totalRow"
          v-model="page.start" @change="changePage" />
      </div>

    </div>
    <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="modalVisible" title="申请加入团队" @ok="actionData"
      :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
      <a-form-model ref="formModel" :rules="formModelRules" :model="formModel" layout="vertical"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="单位名称" prop="unit_id">
          <a-select show-search label-in-value v-model="formModel.uni_id" placeholder="请输入名称搜索单位" style="width: 100%"
            :filter-option="false" @search="searchUnit" @change="changeUni">
            <a-select-option v-for="d in uniList" :key="d.id">
              {{ d.name }}
            </a-select-option>
          </a-select>

        </a-form-model-item>
        <a-form-model-item label="PI" prop="pi_id">
          <a-select show-search option-filter-prop="children" :filter-option="filterOption" v-model="formModel.pi_id" placeholder="请选择PI">
            <a-select-option v-for="d in pIList" :key="d.id">
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="申请人姓名" prop="name">
          <a-input placeholder="请输入申请人姓名" v-model="formModel.name"></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      return {
        modalVisible: false,
        page: {
          start: 1,
          limit: 20,
          pageSize: 0,
          totalRow: 0,
        },
        uniList: [],
        pIList: [],
        list: [],
        formModel: {
          unit_id: undefined,
          pi_id: undefined,
          name: ''
        },
        formModelRules: {
          unit_id: [{ required: true, message: '请输入选择单位', trigger: 'change' }],
          pi_id: [{ required: true, message: '请选择PI', trigger: 'change' }],
          name: [{ required: true, message: '请输入申请人姓名', trigger: 'change' }]
        },
        columns: [
          {
            title: "单位名称",
            dataIndex: "unit_name",
            scopedSlots: { customRender: "unit_name" },
            width: 150
          },
          {
            title: "PI名称",
            dataIndex: "pi_name",
            scopedSlots: { customRender: "pi_name" },
            width: 150
          },
          {
            title: "审核状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" },
            width: 100
          },

          {
            title: "关联时间",
            dataIndex: "create_time",
            scopedSlots: { customRender: "create_time" },
            width: 200
          },
          {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: 100
          },
        ]
      };
    },
    mounted() {
      this.getList();

    },
    methods: {
      filterOption(input, option) {
        return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },

      // 获取当前用户信息
      async getUserInfo () {
        let res = await Api.GetUserInfo({});
        if (res && res["code"] == "0") {
          if (res && res.user.name) {
            console.log(res.user)
            this.formModel.name = res.user.name;
          }
        }
      },
      // 搜索单位名称
      searchUnit(e) {
        if (e.length >= 2) {
          this.searchUnitList(e)
        }
      },

      // 选择单位名称
      changeUni(e) {
        this.pIList = [];
        this.formModel.unit_id = e.key;
        this.formModel.pi_id = undefined;
        this.getPiList();
      },

      // 单位名称搜索列表
      async searchUnitList(name) {
        let res = await Api.SearchUnit({ name: name });
        if (res && res["code"] == "0") {
          this.uniList = res.list;
        }
      },

      // pi列表GetPiList
      async getPiList() {
        let res = await Api.GetPiList({ unit_id: this.formModel.uni_id.key });
        if (res && res["code"] == "0") {
          this.pIList = res.list;
        }
      },
      // 打开添加框
      openModal() {
        this.formModel.uni_id = undefined;
        this.formModel.pi_id = undefined;
        this.formModel.name = '';
        this.modalVisible = true;
        this.getUserInfo();
      },

      // 获取列表
      async getList() {
        let res = await Api.GetList(this.page);
        if (res && res["code"] == "0") {
          this.list = res.page.list;
          this.page.totalRow = res.page.totalRow;
          this.page.pageSize = res.page.pageSize;
        }
      },


      // 切换分页
      changePage(e) {
        this.page.start = e;
        this.getList();
      },

      // 提交数据
      async actionData() {
        this.$refs.formModel.validate(async valid => {
          if (valid) {
            let res = await Api.Save(this.formModel);
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.getList()
              this.modalVisible = false;
            } else {
              this.$message.error(res.message);
            }
          }
        });
      },

      // 解除绑定
      // 删除
      openDelete(id) {
                let that = this;
                this.$confirm({
                    title: "信息提示",
                    okType: "danger",
                    content: "您确定要解除绑定吗",
                    okText: "确定",
                    cancelText: "取消",
                    async onOk() {
                        let res = await Api.Delete({ id: id });
                        if (res && res["code"] == "0") {
                            that.getList();
                            that.$message.success(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    },
                    onCancel() {
                    },
                });
            },

    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
</style>
